var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "modal-box",
    {
      attrs: {
        title: "Crowdfunding Glossary",
        "is-visible": _vm.isVisible,
        icon: "book-open",
        "show-action-close": "",
        width: "wide",
      },
      on: { "action-close": _vm.onModalClose },
    },
    [
      _c(
        "div",
        { staticClass: "_flexcol _gap-6" },
        _vm._l(_vm.dictionary, function (item) {
          return _c(
            "div",
            { key: item.title, staticClass: "_flexcol _gap-1" },
            [
              _c(
                "div",
                { staticClass: "_flex _gap-2" },
                [
                  _c("base-icon", {
                    staticClass: "_tc--accent",
                    attrs: { name: item.icon },
                  }),
                  _vm._v(" "),
                  _c("base-title", { attrs: { level: "h3" } }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(item.title) +
                        "\n                "
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", [
                _vm._v(
                  "\n                " +
                    _vm._s(item.description) +
                    "\n            "
                ),
              ]),
            ]
          )
        }),
        0
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }